// Kayleigh Starr - cloud flipbook player.
// Plays the traced frames forward then backward at 12fps for a seamless loop,
// matching the original ukiyo-clouds-v11 demo exactly.
(function () {
  var FRAMES = window.KLS_CLOUD_FRAMES || [];
  var FPS = 12;
  var el = document.getElementById('kls-live-cloud');
  if (!el || !FRAMES.length) return;

  el.setAttribute('d', FRAMES[0]);

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || FRAMES.length < 2) return;

  // forward then backward => seamless loop
  var order = [];
  for (var i = 0; i < FRAMES.length; i++) order.push(i);
  for (var j = FRAMES.length - 2; j > 0; j--) order.push(j);

  var last = -1, t0 = performance.now();
  function tick(now) {
    var idx = Math.floor(((now - t0) / 1000) * FPS) % order.length;
    if (idx !== last) {
      last = idx;
      el.setAttribute('d', FRAMES[order[idx]]);
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();
